import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useGetAssignmentByVideoIdQuery,
  useGetAssignmentMarksByStudentIdQuery,
} from "../features/assignment/assignmentApi";

const useCheckAssignmentSubmission = ({ id }) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [assignmentMark, setAssignmentMark] = useState({});
  const { id: student_id } = useSelector((state) => state.auth.user);
  const { data: assignment, isLoading: assignmentReqLoading } =
    useGetAssignmentByVideoIdQuery(id);
  const { data: assignmentMarks, isLoading: assignmentMarkReqLoading, refetch } =
    useGetAssignmentMarksByStudentIdQuery(student_id);

    useEffect(() => {
      refetch();
    },[id])

  useEffect(() => {
    if (assignmentMarks?.length > 0) {
      const selectedAssignmentMark = assignmentMarks.find(
        (mark) => mark.assignment_id == assignment[0]?.id
      );
      if (selectedAssignmentMark?.id) {
        setHasSubmitted(true);
        setAssignmentMark(selectedAssignmentMark);

      } else {
        setHasSubmitted(false);
      }
    }
  }, [assignment, assignmentMarks, id]);
  return { hasSubmitted, assignmentMark, assignment };
};

export default useCheckAssignmentSubmission;
